import { defaultNoStrategyDisplayProps } from "./DefaultNoStrategyDisplayProps";
import SelectedStrategy from "./SelectedStrategy";
import findNextUnusedName from "../UtilityComponents/FormUtilityComponents/findNextUnusedName";

function StrategySuggestions(ssl: SelectedStrategy[]) {
  const usedNames = ssl ? ssl.map((ss) => ss.params[0].currentModeStates[ss.params[0].currentModeIndex] as string) : [];

  const noPrimaryStrategy = ssl ? ssl.every((ss) => !ss.primary) : true;

  const lastSuggestionName = findNextUnusedName("Move half to market", usedNames);

  return {
    suggestions: [
      {
        strategy: "Hold",
        params: [{ currentModeIndex: 0, currentModeStates: [findNextUnusedName("Hold", usedNames)] }],
        currentlyDisplayed: false,
        primary: false,
        strategyDisplayProps: defaultNoStrategyDisplayProps,
      },
      {
        strategy: "Sell Newly Vested",
        params: [
          { currentModeIndex: 0, currentModeStates: [findNextUnusedName("Sell half", usedNames)] },
          { currentModeIndex: 0, currentModeStates: [50, null] },
          { currentModeIndex: 0, currentModeStates: [null, null] },
        ],
        currentlyDisplayed: false,
        primary: false,
        strategyDisplayProps: defaultNoStrategyDisplayProps,
      },
      {
        strategy: "Sell Newly Vested",
        params: [
          { currentModeIndex: 0, currentModeStates: [lastSuggestionName] },
          { currentModeIndex: 0, currentModeStates: [50, null] },
          { currentModeIndex: 1, currentModeStates: [null, "SPY"] },
        ],
        currentlyDisplayed: true,
        primary: noPrimaryStrategy,
        strategyDisplayProps: defaultNoStrategyDisplayProps,
      },
    ],
    snackbarPrimaryName: noPrimaryStrategy ? lastSuggestionName.trim() : undefined,
  };
}

export default StrategySuggestions;
